export async function fetchJson(url: string, init?: RequestInit) {
  const res = await fetch(url, init);
  const text = await res.text();
  if (!res.ok) {
    let payload: any;
    try { payload = JSON.parse(text); } catch { payload = { error: text }; }
    const err: any = new Error(payload?.error || payload?.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return text ? JSON.parse(text) : {};
}
